import * as yup from "yup";

export const schema = yup.object().shape({
  plan_id: yup.number().required(),
  agent_ids: yup.array().required(),
});
